// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"396": "be932586","48": "2745104d","531": "b6d5624c","650": "2b6ea00a","672": "a6d32b8b","75": "5628f622","971": "33061a75","991": "9746022b",}[chunkId] + ".js"
}